import { useState, useEffect, useRef } from 'react';
import { ServiceModel } from '../../../data/entities';
import { ServiceDetailsPage, ServiceLocationsPage, ServiceTopbar } from '../';
import { sharedProperty, useTenantFeatures } from '../../../hooks';
import { Button, IconAndText, IconDefinitions, SlideOutModal, SlideOutModalProps } from '../../../components';

interface ManageServiceModalProps extends SlideOutModalProps {
  dataItemState: sharedProperty<ServiceModel>;
  showState: sharedProperty<boolean>;
  onSubmit: any;
}

export function ManageServiceModal(props: Readonly<ManageServiceModalProps>) {

  const { manageLocationServices, manageServiceTypes } = useTenantFeatures();
  const defaultTab = manageServiceTypes ? 'Details' : 'Locations';
  const [activeTab, setActiveTab] = useState<string>(defaultTab);

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [props.dataItemState.value.id, defaultTab])

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };
  const serviceDetailsRef = useRef<any>(null);
  const serviceLocationsRef = useRef<any>(null);

  const renderFooter = () => {
    if(activeTab === 'Locations') {
      return (
        <div className="container p-0">
          <div className="row g-0">
            <div className="col-12 pe-2">
              <Button
                onClick={() => props.showState.setter(false)}
                variant="cancel"
                className="w-100"
              >
                Cancel
              </Button>
            </div>
            {manageLocationServices && (
              <div className="col-12 ps-2">
                <Button
                  onClick={() => serviceLocationsRef.current?.addLocation()}
                  className="w-100"
                >
                  <IconAndText iconName={IconDefinitions.add} text="Add New Location" className="justify-content-center"/>
                </Button>
              </div>
            )}
          </div>
        </div>
      );
    }
    if(activeTab === 'Details') {
      return (
        <div className="container p-0">
          <div className="row g-0">
            <div className="col-12 pe-2">
              <Button
                onClick={() => props.showState.setter(false)}
                variant="cancel"
                className="w-100"
              >
                Cancel
              </Button>
            </div>
            <div className="col-12 ps-2">
              <Button
                onClick={() => serviceDetailsRef.current?.submit()}
                variant="primary"
                className="w-100"
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      );
    }
  }

  return (
    <SlideOutModal {...props}
      title={`${props.dataItemState.value.name}`}
      bodyClassName="p-0"
      size='lg'
      topbar={
        <ServiceTopbar onChangeTab={handleTabChange} />
      }
      onHide={() => { setActiveTab(defaultTab) }}
      footer={renderFooter()}
    >
      {activeTab === 'Details' && (
        <ServiceDetailsPage dataItemState={props.dataItemState} showState={props.showState} onSubmit={props.onSubmit} ref={serviceDetailsRef} />
      )}

      {activeTab === 'Locations' && (
        <ServiceLocationsPage service={props.dataItemState.value} showState={props.showState} ref={serviceLocationsRef} />
      )}
      {props.children}
    </SlideOutModal>
  )
}

export default ManageServiceModal;
